<template>
    <div>
        <b-form-group label="Berat Tambahan" description="Hubungi kantor pusat untuk menentukan berat tambahan">
            <b-row no-gutters>
                <b-col cols='2' lg="1">
                    <b-form-checkbox class="mt-2 ml-2 mr-2" v-model="checkBeratTambahan"></b-form-checkbox>
                </b-col>
                <b-col cols="10" lg="8">
                    <b-input-group append="Gram">
                        <b-form-input :disabled="checkBeratTambahan == false" @blur="$emit('roundPersenBeratTambahan')"
                            v-model="input.beratTambahan" name="beratTambahan" min="0" step="0.01"
                            type="number"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-form-group>
    </div>
</template>
<script>
export default {
    props: {
        input: { required: true },
      
    },

    data(){
        return {
            checkBeratTambahan : false
        }
    },

    watch:{
        'checkBeratTambahan' : function(newVal) {
            this.$emit('checkBeratTambahan' , newVal)
        }
    }
}
</script>